<template>
  <div class="v3-popup feedback-success-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content small">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title">{{ langData.feedbackSuccessTitle }}</div>
      <div class="v3-popup-content-content">{{ langData.feedbackSuccessContent }}</div>
      <div class="v3-popup-content-footer">
        <div class="confirm-btn btns" @click="handleClose">{{ langData.confirmBtn }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LanguageHook from "@/hooks/language";

const { langData } = LanguageHook();

const emit = defineEmits(["close"]);

const handleClose = () => {
  emit("close");
};
</script>

<style scoped lang="less"></style>
